import PropTypes from 'prop-types'

import EllipsisText from 'react-ellipsis-text'
import ReactSVG from 'react-svg'
import React from 'react'
import { Star } from '../../public/static/svgs/Star'
import { WidgetContainer, Wrapper } from './styles'

export const PerformanceWidget = ({
  className,
  onPress,
  onSelect,
  filled,
  first,
  last,
  artist: {
    photo, name: artistName, id: artistId, slug: artistSlug
  },
  place: {
    name: placeName, id: placeId, slug: placeSlug
  }, time, selected
}) => (
  <Wrapper>
    <div className="routeLine">
      <ReactSVG src={`/static/images/${(first || last) ? 'filled' : 'middle'}-route-dot.svg`} className="dot" />
      {first && (<span className="widgetLine" />)}
    </div>
    <WidgetContainer
      className={className}
      selected={selected}
      onClick={onSelect}
    >
      <button onClick={(e) => {
        onPress()
        e.stopPropagation()
      }}
      >
        <Star className="starSvg" filled={filled} />
      </button>
      <div className="infoBlock">
        <span className="time">{time}</span>
        <a
          className="artistName"
          href={`/artist/${artistId}/${artistSlug}`}
        >
          {artistName}
        </a>
        <a
          className="placeName"
          href={`/place/${placeId}/${placeSlug}`}
        >
          <EllipsisText text={placeName} length={40} />
        </a>
      </div>
      <img className="photo" src={photo || '/static/images/empty-artist.svg'} alt="performance" />
    </WidgetContainer>
  </Wrapper>
)

PerformanceWidget.propTypes = {
  onPress: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  artist: PropTypes.instanceOf(Object).isRequired,
  place: PropTypes.instanceOf(Object).isRequired,
  time: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  first: PropTypes.bool,
  last: PropTypes.bool,
  selected: PropTypes.bool
}

PerformanceWidget.defaultProps = {
  className: undefined,
  filled: false,
  first: false,
  last: false,
  selected: false
}
